<template>
    <div v-if="hasGetData" class="sync-set-box">
        <steps-head :title="$t('请选择同步方式')"></steps-head>
        <div class="sync-set-tip sync-set-txt-orange">{{ $t('同步方式选定后，暂不支持更改，请谨慎选择') }}</div>
        <div class="sync-set-type">
            <div class="sync-set-type-item" :class="isSelectSyncMode2 ? 'is-select' : ''" @click="syncMode = 2">
                <div class="sync-set-type-item-title">
                    <div class="sync-set-type-item-icon"><v-icon name="import1" /></div>
                    <div class="sync-set-type-item-desc">
                        <h4>
                            {{ $t('从企业微信导入员工到企点') }}
                            <div v-if="recommendSyncMode === 2" class="sync-set-type-item-recommend">{{ $t('推荐') }}</div>
                        </h4>
                        <p>{{ $t('如果部分员工使用企点，部分使用企业微信，推荐用该方式') }}</p>
                    </div>
                </div>
                <div class="sync-set-type-item-content">
                    <ul>
                        <li>{{ $t('创建员工：可以从企业微信导入员工到企点，也可以在企点中创建员工') }}</li>
                        <li>{{ $t('员工信息同步：不自动同步') }}</li>
                        <li>{{ $t('在企业微信上使用企点应用的范围：从企业微信导入的员工') }}</li>
                    </ul>
                </div>
            </div>
            <div class="sync-set-type-item" :class="isSelectSyncMode1 ? 'is-select' : ''" @click="syncMode = 1">
                <div class="sync-set-type-item-title">
                    <div class="sync-set-type-item-icon"><v-icon name="link3" /></div>
                    <div class="sync-set-type-item-desc">
                        <h4>
                            {{ $t('完全使用企业微信的通讯录') }}
                            <div v-if="recommendSyncMode === 1" class="sync-set-type-item-recommend">{{ $t('推荐') }}</div>
                        </h4>
                        <p>{{ $t('如果所有员工都只使用企业微信，推荐用该方式') }}</p>
                    </div>
                </div>
                <div class="sync-set-type-item-content">
                    <ul>
                        <li>{{ $t('创建员工：只能从企业微信创建员工，企点中无法创建员工') }}</li>
                        <li>{{ $t('员工信息同步：自动同步') }}</li>
                        <li>{{ $t('在企业微信上使用企点应用的范围：所有员工') }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="isSelectSyncMode2" class="sync-set-tip sync-set-txt-gray">
            {{ $t('可稍后在「组织架构」中导入企业微信员工') }}
        </div>

        <div v-if="isSelectSyncMode1" class="sync-set-rule-box">
            <steps-head :title="$t('配置同步规则')"></steps-head>
            <sync-rule ref="syncRule"></sync-rule>
        </div>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import { hasPackage } from '@/utils/package';
import StepsHead from '../../steps-head';
import SyncRule from '../../sync-rule';
const sprites = require.context('src/assets/icons', true, /[^.]+\.svg$/);
Icon.addSprites(sprites);

export default {
    components: {
        StepsHead,
        SyncRule
    },

    data() {
        return {
            hasGetData: false,

            // 推荐同步方式 只有SSC推荐自动同步 其他推荐手动
            recommendSyncMode: hasPackage('10058') ? 1 : 2,
            syncMode: 0
        };
    },

    computed: {
        isSelectSyncMode1() {
            return this.syncMode === 1;
        },

        isSelectSyncMode2() {
            return this.syncMode === 2;
        }
    },

    created() {
        this.getSyncConfig();
    },

    methods: {
        // 企业微信通讯录同步配置获取
        getSyncConfig() {
            this.syncMode = this.recommendSyncMode;
            this.hasGetData = true;
        },

        validate() {
            let isValid = true;

            if (!this.syncMode) {
                isValid = false;
                this.$message.error(this.$t('请选择同步方式'));
            } else if (this.isSelectSyncMode1) {
                isValid = this.$refs.syncRule.validate();
            }

            return isValid;
        },

        getData() {
            let reqData = { sync_mode: this.syncMode };

            if (this.isSelectSyncMode1) {
                const ruleData = this.$refs.syncRule.getData();
                reqData = { ...reqData, ...ruleData };
            }

            return reqData;
        }
    }
};
</script>
<style lang="less" scoped>
@import './sync-set.less';
</style>
